import { render, staticRenderFns } from "./purchaseItemDetails.vue?vue&type=template&id=7074588a&scoped=true&"
import script from "./purchaseItemDetails.vue?vue&type=script&lang=js&"
export * from "./purchaseItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./purchaseItemDetails.vue?vue&type=style&index=0&id=7074588a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074588a",
  null
  
)

export default component.exports